import { Component, HostListener, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnalyticsService } from '../../@core/utils';
import { Classroom } from '../../interface/calendar';
import { LessonPlanService } from '../../services/lesson-plan.service';
import { PacingPlanService } from '../../services/pacing-plan.service';
import { StorageService } from '../../services/storage.service';
import { StudentService } from '../../services/student.service';
import { TeacherLessonPlanService } from '../../services/teacher-lesson-plan.service';

@Component({
  selector: 'ngx-student-previous-lessons',
  templateUrl: './student-previous-lessons.component.html',
  styleUrls: ['./student-previous-lessons.component.scss'],
})
export class StudentPreviousLessonsComponent implements OnInit {
  @Input() classroom: Classroom;
  @Input() isExpand = false;
  currentPage = 1;
  totalPages = 1;
  studentLessonPlans = [];
  loading = false;
  public isMobileScreen = window.innerWidth <= 767;

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.isMobileScreen = event.target.innerWidth <= 767;
  }

  constructor(
    private teacherLessonPlanService: TeacherLessonPlanService,
    private studentService: StudentService,
    private lessonPlanService: LessonPlanService,
    private sanitizer: DomSanitizer,
    public router: Router,
    public alayticsService: AnalyticsService,
    private pacingPlanService: PacingPlanService,
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
  ) {}

  async ngOnInit() {
    try {
      this.loading = true;
      this.spinner.show();
      if (this.classroom) {
        await this.getStudentsLessonPlans();
      }
      this.loading = false;

      this.studentService.currentClassroom.subscribe(async (x: Classroom) => {
        if (x) {
          this.loading = true;
          this.classroom = x;
          this.currentPage = 1;
          await this.getStudentsLessonPlans();
          this.loading = false;
        }
      });

      this.pacingPlanService.studentCurrentSubject.subscribe(async (x) => {
        this.loading = true;
        this.currentPage = 1;
        this.classroom['current_subject_id'] = x;
        await this.getStudentsLessonPlans();
        this.loading = false;
      });
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      this.loading = false;
      // console.log(error);
    }
  }

  async getStudentLessonPlanByPage() {
    try {
      // this.loading = true;
      this.spinner.show();
      await this.getStudentsLessonPlans();
      // this.loading = false;
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      // console.log(error);
    }
  }

  async getStudentsLessonPlans() {
    try {
      const body = {
        subject_id: this.classroom?.current_subject_id,
        user_id: this.classroom?.user_id,
        grades_id: this.classroom?.grades_id,
        page: this.currentPage,
        isExpand: this.isExpand,
        classroom_id: this.classroom?.id,
      };

      const response: any = await this.teacherLessonPlanService.getStudentTeacherLessonPlan(body);
      this.totalPages = response.pageTotal;

      this.studentLessonPlans = response.items;
      this.studentLessonPlans = this.studentLessonPlans.map((plan) => {
        const pacingPlan = plan.lesson_plan.pacing_plan_id || [];
        const customPlan = plan.lesson_plan.teacher_custom_pacing_plans_id || [];

        const pacingArray = Array.isArray(pacingPlan) ? pacingPlan : [pacingPlan];
        const customArray = Array.isArray(customPlan) ? customPlan : [customPlan];

        const allPlans = [...pacingArray, ...customArray].filter((p) => p);

        const sectionIds = allPlans.map((p) => p.section_id || '-').join('\n');
        const sectionTitles = allPlans.map((p) => p.section_title || '-').join('. \n');

        return {
          ...plan,
          plan: {
            section_id: sectionIds,
            section_title: sectionTitles,
          },
        };
      });
      this.updateStudentLessonPlan();
    } catch (error) {
      // console.log(error);
    }
  }

  updateStudentLessonPlan() {
    try {
      this.studentLessonPlans.map(async (x) => {
        x?.updates[7]?.video_urls?.length > 0
          ? (x.updates[7].video_urls = this.getSafeUrls(x?.updates[7]?.video_urls))
          : [];

        x?.updates[6]?.lesson_plan_media_id > 0
          ? (x.updates[6].lesson_plan_media_id = await this.lessonPlanService.getLessonPlanMedia(
              x?.updates[6]?.lesson_plan_media_id,
            ))
          : null;

        return x;
      });
    } catch (error) {
      // console.log(error);
    }
  }

  getSafeUrls(urls) {
    try {
      return urls.map((x) => {
        const newUrl = x.replace('watch?v=', 'embed/');
        x = this.sanitizer.bypassSecurityTrustResourceUrl(newUrl);
        return x;
      });
    } catch (error) {
      // console.log(error);
    }
  }

  closeDialog() {
    this.studentService.isExpand.emit({
      isExpand: false,
      compontentLabel: 'previous-lessons',
    });
  }

  renderToLessonPlan(lessonPlan) {
    try {
      this.closeDialog();

      this.studentService.isExpand.emit({
        isExpand: true,
        compontentLabel: 'student-lesson-plan',
        data: lessonPlan,
        isExpandlessonPlan: this.isExpand,
      });

      this.storageService.setItem('lesson-plan-start-time', new Date().getTime());
    } catch (error) {
      // console.log(error);
    }
  }
}
